import { Mail, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ExerciseSharingButtons({
  exerciseIds = [],
  playlistId,
  patientId,
  disabled = false,
  compact = false,
  printLabel = "Print Worksheet",
  sendLabel = "Send to Patient",
}) {
  const query = new URLSearchParams();
  if (playlistId) query.set("playlist", playlistId);
  else exerciseIds.forEach((id) => query.append("exercise", id));
  if (patientId) query.set("patient", patientId);
  const open = (mode) => {
    query.set("mode", mode);
    // A fresh document keeps analytics from the library out of the patient worksheet.
    window.location.assign(`/admin/exercise-programs/new?${query}`);
  };
  const unavailable = disabled || (!playlistId && !exerciseIds.length);
  return <div className="flex flex-wrap gap-2">
    <Button variant="outline" size="sm" disabled={unavailable} onClick={() => open("print")}><Printer size={compact ? 15 : 16} /> {printLabel}</Button>
    <Button size="sm" disabled={unavailable} onClick={() => open("email")}><Mail size={compact ? 15 : 16} /> {sendLabel}</Button>
  </div>;
}
